module.exports = __webpack_public_path__ + "media/images/samples/1280x768/3-702998f1677421340db4dddea129a9a9.jpg";